import Space from './src/index';

Space.install = (app) => {
    app.component(Space.name, Space);
};

export default Space;

declare module 'vue' {
    export interface GlobalComponents {
        PtSpace: typeof Space;
    }
}
